import { Helmet } from 'react-helmet';
import { FormattedMessage, useIntl } from 'react-intl';

// COMPONENTS
import TaxesTable from './TaxesTable';
import { CanOrNotFound } from 'permissions';
import { ChargesTable } from './Charges.components';

// ASSETS
import PaymentIcon from 'assets/PaymentIcon';

// STYLES
import { Section, SectionHeader, SectionHeaderTitle } from 'styles/cards';
import { PageContent } from './styles';
import colors from 'styles/colors';

// CONSTANTS
import { DotAppRoute, FleetSettingsSideMenuItem, UserPermission } from 'constants/common';

export const Charges = () => {
  const { formatMessage } = useIntl();

  return (
    <CanOrNotFound I={UserPermission.VIEW} a={DotAppRoute.SETTINGS} field={FleetSettingsSideMenuItem.CHARGES}>
      <PageContent>
        <Helmet>
          <title>
            {formatMessage({
              id: 'views.Settings.helmetTitle',
            })}
          </title>
          <meta
            name="settings"
            content={formatMessage({
              id: 'views.Settings.helmetDescription',
            })}
          />
        </Helmet>

        <Section>
          <SectionHeader>
            <SectionHeaderTitle>
              <PaymentIcon color={colors.fleetBlue} />
              <FormattedMessage id="views.FleetSettings.Charges.catalog" />
            </SectionHeaderTitle>
          </SectionHeader>
          <ChargesTable />
        </Section>
        <TaxesTable />
      </PageContent>
    </CanOrNotFound>
  );
};

export default Charges;
